module.exports = __webpack_public_path__ + "static/media/next.7dcac274.svg";